import React, { FC as ReactFC } from 'react';

import BlockUi from 'react-block-ui';
import * as intl from 'react-intl-universal';
import {
  Alert,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import RecoveryCodeContainer from 'shared/components/recovery-code-container/RecoveryCodeContainer';
import Status from 'shared/enums/Status';

import styles from './mfaRecoveryGenerationModal.module.scss';
import MfaRecoveryGenerationModalProps from './MfaRecoveryGenerationModalProps';

const MfaRecoveryGenerationModal: ReactFC<MfaRecoveryGenerationModalProps> = (
  props: MfaRecoveryGenerationModalProps
) => {
  const { isOpen, recoveryCodes, status, onToggle } = props;

  return (
    <Modal
      size="md"
      isOpen={isOpen}
      toggle={onToggle}
      backdrop="static"
      centered
      autoFocus={false}
      trapFocus
      keyboard={false}
      id="warningPromptTarget"
    >
      <BlockUi tag="div" blocking={status === Status.Loading}>
        <ModalHeader toggle={onToggle}>
          {intl.get('LBL_MFA_RECOVERY_GENERATION_MODAL_TITLE')}
        </ModalHeader>
        <ModalBody>
          <Col xs="12">
            <Row>
              {intl.get('LBL_MFA_RECOVERY_GENERATION_MODAL_DESCRIPTION')}
            </Row>
            <Row className="d-flex flex-column align-items-center">
              <RecoveryCodeContainer recoveryCodes={recoveryCodes} />
            </Row>
            <Row>
              <Col xs="12" className="p-0">
                <Alert color="light" className={styles.noteSection}>
                  <strong
                    className={`text-14-bold text-uppercase ${styles.noteTitle}`}
                  >
                    {intl.get('LBL_MFA_RECOVERY_GENERATION_NOTE_TITLE')}
                  </strong>
                  <ol className={styles.noteList}>
                    <li className={`text-12-medium ${styles.noteListItem}`}>
                      {intl.getHTML('LBL_MFA_RECOVERY_GENERATION_NOTE_1')}
                    </li>
                    <li className={`text-12-medium ${styles.noteListItem}`}>
                      {intl.get('LBL_MFA_RECOVERY_GENERATION_NOTE_2')}{' '}
                    </li>
                    <li className={`text-12-medium ${styles.noteListItem}`}>
                      {intl.get('LBL_MFA_RECOVERY_GENERATION_NOTE_3')}{' '}
                    </li>
                  </ol>
                </Alert>
              </Col>
            </Row>
          </Col>
        </ModalBody>
        <ModalFooter className="p-3">
          <Col xs="12" className="d-flex justify-content-center">
            <Button
              color="primary"
              onClick={onToggle}
              className="d-flex justify-content-center w-100"
            >
              {intl.get('BTN_MFA_RECOVERY_DONE')}
            </Button>
          </Col>
        </ModalFooter>
      </BlockUi>
    </Modal>
  );
};

export default MfaRecoveryGenerationModal;
